module.exports = __webpack_public_path__ + "static/media/dengue_icon_myway.336a3646.svg";